import { useState, useEffect } from 'react';
import { supabase } from '../supabase-client';

const useAdministradores = () => {
   const [administradores, setAdministradores] = useState([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState(null);

   const fetchAdministradores = async () => {
      setLoading(true);
      setError(null);
      
      try {
         const { error, data } = await supabase
            .from("admin_users")
            .select(`
               id,
               usuario,
               email,
               recibemails
            `)
            .eq("recibemails", "S")
            .order("created_at", { ascending: true });
            
         if (error) {
            console.error("Error reading admin users:", error.message);
            setError(error.message);
            return;
         }
         
         setAdministradores(data || []);
      } catch (err) {
         console.error("Unexpected error:", err);
         setError(err.message);
      } finally {
         setLoading(false);
      }
   };

   useEffect(() => {
      fetchAdministradores();
   }, []);

   return { 
      administradores, 
      loading, 
      error, 
      refetch: fetchAdministradores 
   };
};

export default useAdministradores;